import React from 'react';
import { Shield, Wifi, Activity, AlertTriangle, CheckCircle, Server, Eye, Heart, Factory, Building, Smartphone, Home, Car, Monitor } from 'lucide-react';

const IoTOverviewTab = ({ overview }) => (
  <div className="space-y-6">
          {/* Stats Cards */}
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
            <div className="bg-white p-4 rounded-xl border shadow-sm">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-cyan-100 rounded-lg">
                  <Cpu className="h-5 w-5 text-cyan-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">{overview.summary?.total_endpoints || 0}</p>
                  <p className="text-xs text-gray-500">Total Endpoints</p>
                </div>
              </div>
            </div>
            
            <div className="bg-white p-4 rounded-xl border shadow-sm">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-green-100 rounded-lg">
                  <CheckCircle className="h-5 w-5 text-green-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">{overview.summary?.healthy_endpoints || 0}</p>
                  <p className="text-xs text-gray-500">Healthy</p>
                </div>
              </div>
            </div>
            
            <div className="bg-white p-4 rounded-xl border shadow-sm">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-yellow-100 rounded-lg">
                  <AlertTriangle className="h-5 w-5 text-yellow-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">{overview.summary?.active_anomalies || 0}</p>
                  <p className="text-xs text-gray-500">Anomalies</p>
                </div>
              </div>
            </div>
            
            <div className="bg-white p-4 rounded-xl border shadow-sm">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-red-100 rounded-lg">
                  <XCircle className="h-5 w-5 text-red-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">{overview.summary?.vulnerable_devices || 0}</p>
                  <p className="text-xs text-gray-500">Vulnerable</p>
                </div>
              </div>
            </div>
            
            <div className="bg-white p-4 rounded-xl border shadow-sm">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-blue-100 rounded-lg">
                  <Shield className="h-5 w-5 text-blue-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">{overview.summary?.firmware_scans || 0}</p>
                  <p className="text-xs text-gray-500">Scans Run</p>
                </div>
              </div>
            </div>
            
            <div className="bg-white p-4 rounded-xl border shadow-sm">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-purple-100 rounded-lg">
                  <Activity className="h-5 w-5 text-purple-600" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">{overview.summary?.health_percentage || 0}%</p>
                  <p className="text-xs text-gray-500">Health Score</p>
                </div>
              </div>
            </div>
          </div>

          {/* Categories */}
          <div className="bg-white rounded-xl border shadow-sm p-6">
            <h3 className="font-semibold text-gray-900 mb-4">Endpoints by Category</h3>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
              {Object.entries(overview.by_category || {}).map(([category, count]) => {
                const CategoryIcon = getCategoryIcon(category);
                return (
                  <div key={category} className="text-center p-4 bg-gray-50 rounded-lg">
                    <CategoryIcon className="h-8 w-8 text-cyan-600 mx-auto mb-2" />
                    <p className="text-lg font-bold text-gray-900">{count}</p>
                    <p className="text-xs text-gray-500 capitalize">{category.replace('_', ' ')}</p>
                  </div>
                );
              })}
              {Object.keys(overview.by_category || {}).length === 0 && (
                <p className="text-gray-500 text-sm col-span-5">No endpoints registered yet</p>
              )}
            </div>
          </div>

          {/* Features Banner */}
          <div className="bg-gradient-to-r from-cyan-600 to-blue-600 rounded-xl p-6 text-white">
            <h3 className="text-lg font-semibold mb-4">IoT Security Features</h3>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
              <div className="flex items-center gap-2">
                <Monitor className="h-5 w-5" />
                <span className="text-sm">Endpoint Monitoring</span>
              </div>
              <div className="flex items-center gap-2">
                <Wifi className="h-5 w-5" />
                <span className="text-sm">Traffic Analysis</span>
              </div>
              <div className="flex items-center gap-2">
                <Activity className="h-5 w-5" />
                <span className="text-sm">Anomaly Detection</span>
              </div>
              <div className="flex items-center gap-2">
                <Shield className="h-5 w-5" />
                <span className="text-sm">Firmware Scanning</span>
              </div>
              <div className="flex items-center gap-2">
                <Lock className="h-5 w-5" />
                <span className="text-sm">Access Control</span>
              </div>
            </div>
          </div>
        </div>
);

export default IoTOverviewTab;
